import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpContentType, HttpHeaders, HttpMethod } from "../../../common/api/http";
import { EntityObject } from "../../../common/types";
import {
  CreateVehicleMapping,
  UpdateVehicleMappingList,
  VehicleBrandMappingFilterPageResult,
  VehicleMapping,
  VehicleMappingData,
  VehicleMappingFilterPageRequest,
  VehicleMappingTypesRequest,
  VehicleModelMappingFilterPageResult,
} from "./types";

const GET_VEHICLE_MAPPINGS = ApiRequestAdapter.create("/vehicles/mappings", HttpMethod.GET);
const REMAP_VEHICLE_MAPPINGS = ApiRequestAdapter.create("/vehicles/mappings/remap", HttpMethod.POST);
const MAP_VEHICLE_MAPPINGS_UPDATES = ApiRequestAdapter.create("/vehicles/mappings/map-updates", HttpMethod.POST);
const UNMAP_OBSOLETE_VEHICLE_MAPPINGS = ApiRequestAdapter.create("/vehicles/mappings/unmap-obsolete", HttpMethod.POST);
const IMPORT_VEHICLE_MAPPINGS = ApiRequestAdapter.create("/vehicles/mappings/import", HttpMethod.POST);
const EXPORT_VEHICLE_MAPPINGS = ApiRequestAdapter.create("/vehicles/mappings/export", HttpMethod.GET);
const FILTER_VEHICLE_BRANDS = ApiRequestAdapter.create("/vehicles/mappings/brands", HttpMethod.GET);
const CREATE_VEHICLE_BRAND_MAPPING = ApiRequestAdapter.create("/vehicles/mappings/brands", HttpMethod.POST);
const UPDATE_VEHICLE_BRAND_MAPPINGS = ApiRequestAdapter.create("/vehicles/mappings/brands", HttpMethod.PUT);
const FILTER_VEHICLE_MODELS = ApiRequestAdapter.create("/vehicles/mappings/brands/{0}/models", HttpMethod.GET);
const CREATE_VEHICLE_MODEL_MAPPING = ApiRequestAdapter.create("/vehicles/mappings/brands/{0}/models", HttpMethod.POST);
const UPDATE_VEHICLE_MODEL_MAPPINGS = ApiRequestAdapter.create("/vehicles/mappings/brands/{0}/models", HttpMethod.PUT);

export const vehicleBrandApi = {
  getVehicleMappings: (request: VehicleMappingTypesRequest): AxiosPromise<VehicleMappingData[]> => {
    return apiService.get(GET_VEHICLE_MAPPINGS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  remapVehicleMappings: (request: VehicleMappingTypesRequest): AxiosPromise<void> => {
    return apiService.post(REMAP_VEHICLE_MAPPINGS.url, null, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  mapVehicleMappingsUpdates: (request: VehicleMappingTypesRequest): AxiosPromise<void> => {
    return apiService.post(MAP_VEHICLE_MAPPINGS_UPDATES.url, null, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  unmapObsoleteVehicleMappings: (request: VehicleMappingTypesRequest): AxiosPromise<void> => {
    return apiService.post(UNMAP_OBSOLETE_VEHICLE_MAPPINGS.url, null, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  importVehicleMappings: (request: FormData): AxiosPromise<void> => {
    return apiService.post(IMPORT_VEHICLE_MAPPINGS.url, request, {
      headers: { [HttpHeaders.CONTENT_TYPE]: HttpContentType.MULTIPART_FORM_DATA },
    });
  },
  exportVehicleMappings: (): AxiosPromise<Blob> => {
    return apiService.get(EXPORT_VEHICLE_MAPPINGS.url, { responseType: "blob" });
  },
  filterVehicleBrands: (
    request: VehicleMappingFilterPageRequest,
  ): AxiosPromise<VehicleBrandMappingFilterPageResult> => {
    return apiService.get(FILTER_VEHICLE_BRANDS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createVehicleBrandMapping: (request: CreateVehicleMapping): AxiosPromise<VehicleMapping> => {
    return apiService.post(CREATE_VEHICLE_BRAND_MAPPING.url, request);
  },
  updateVehicleBrandMappings: (request: UpdateVehicleMappingList): AxiosPromise<VehicleMapping[]> => {
    return apiService.put(UPDATE_VEHICLE_BRAND_MAPPINGS.url, request);
  },
  filterVehicleModels: (
    request: EntityObject<VehicleMappingFilterPageRequest>,
  ): AxiosPromise<VehicleModelMappingFilterPageResult> => {
    return apiService.get(FILTER_VEHICLE_MODELS.getParametrizedUrl(request.id), {
      params: request.object,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createVehicleModelMapping: (request: EntityObject<CreateVehicleMapping>): AxiosPromise<VehicleMapping> => {
    return apiService.post(CREATE_VEHICLE_MODEL_MAPPING.getParametrizedUrl(request.id), request.object);
  },
  updateVehicleModelMappings: (request: EntityObject<UpdateVehicleMappingList>): AxiosPromise<VehicleMapping[]> => {
    return apiService.put(UPDATE_VEHICLE_MODEL_MAPPINGS.getParametrizedUrl(request.id), request.object);
  },
};
